import React, { useEffect, useState } from "react";
import AboutUs from "../components/AboutUs";
import WorkingProcess from "../components/WorkingProcess";
import Services from "../components/Services";
import Testimonial from "../components/Testimonial";
import LatestNews from "../components/LatestNews";
import { fetchBlogsPage } from "../api/blogsPage";
import { useHomePage } from "../context/HomePageContext";

const HomePage = () => {
  const { about, workingProcesses, testimonials, services } = useHomePage();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadBlogs = async () => {
      try {
        const data = await fetchBlogsPage();
        if (isMounted) {
          setBlogs(data.blogs || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadBlogs();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <AboutUs about={about} />
      <WorkingProcess steps={workingProcesses} />
      <Services services={services} />
      <Testimonial testimonials={testimonials} />
      <LatestNews newsItems={blogs} />
    </>
  );
};

export default HomePage;
